// extracted by mini-css-extract-plugin
module.exports = {"pcc_container":"paymentConfirmContent_pcc_container__2ysHH","warning_image":"paymentConfirmContent_warning_image__FhVdO","close":"paymentConfirmContent_close__wWHs9"};